import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { Modal } from "react-bootstrap";
import http from "../../../Common/http-common";
import * as common from "../../../Common/common";
import * as Comp from "../../../Common/CommonComponents";
import BackModal from '../../../Components/BasicElements/BackModal';
import ConfirmModal from '../../../Components/BasicElements/ConfirmModal';
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

const LeaveRejected = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const [username] = useState(cookies.USERNAME);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading....");
  const [editData, setEditData] = useState([]);
  const [inputError, setInputError] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const [showBackModal, setShowBackModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  useEffect(() => {
    if (props.editData !== null) {
      setEditData({
				LEAVE_MST_ID: props.editData.LEAVE_MST_ID === null ? "" : props.editData.LEAVE_MST_ID,
        USER_MST_GUID: props.editData.USER_MST_GUID === null ? "" : props.editData.USER_MST_GUID,
				USERNAME: props.editData.USERNAME === null ? "" : props.editData.USERNAME,
        STATUS: props.editData.STATUS === null ? "" : props.editData.STATUS,
        LEAVE_TYPE: props.editData.LEAVE_TYPE === null ? "" : props.editData.LEAVE_TYPE,
        LEAVE_SESSION: props.editData.LEAVE_SESSION === null ? "" : props.editData.LEAVE_SESSION,
        REASON: props.editData.REASON === null ? "" : props.editData.REASON,
      })
    }
  }, [props.editData]);

	function SaveRejectedLeave() {
    let functionName = "";
    try {
      functionName = SaveRejectedLeave.name;
      props.onLoading(true, "Rejecting this leave, please wait...");
      const data = {
				LEAVE_MST_ID: editData.LEAVE_MST_ID,
        USER_MST_GUID: editData.USER_MST_GUID,
        USERNAME: editData.USERNAME,
        LEAVE_TYPE: editData.LEAVE_TYPE,
        LEAVE_SESSION: editData.LEAVE_SESSION,
        REASON: editData.REASON,
        REMARK: editData.REMARK,
        UPDATE_ID: userId,
        UPDATE_NAME: username,
        FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
			};
      http
        .post("api/leaveHistory/RejectLeave", data, { timeout: 5000 })
        .then((response) => {
          toast.success("Leave application is successfully rejected.");
          props.onReload();
        })
        .catch((err) => {
          toast.error("Failed to reject leave. Please try again.1");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
    } catch (err) {
      props.onLoading(false, "Loading...");
      toast.error("Failed to reject leave. Please try again.2");
      common.c_LogWebError(props.page, functionName, err);
    }
  };

	const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: (name + " could not be empty."),
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: (""),
        }));
      }
      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
    setHasChanges(true);
  }

	//#region Event Handler
  const hideModal = () => {
    setEditData([]);
    setInputError([]);
		setHasChanges(false);
    props.onHide();
  };

	const handleBack = () => {
		if (hasChanges) {
			setShowBackModal(true);
		} else {
			hideModal();
		}
	};

	const handleConfirmBack = () => {
		setShowBackModal(false); // Hide back modal
    setEditData([]);
		hideModal();
		setHasChanges(false);
	};

	const handleConfirmBackCancel = () => {
		setShowBackModal(false); // Hide back modal
	};

  const handleConfirm = () => {
    if (editData.REMARK === undefined) {
			setInputError((prevState) => ({
				...prevState,
				REMARK: ("Reject reason could not be empty."),
			}));
      return;
		}
    
    if (Object.values(inputError).filter(v => v !== "").length === 0) {
      setShowConfirmModal(true);
    }
  };

  const handleConfirmModal = () => {
    SaveRejectedLeave();
    setShowConfirmModal(false); // Hide confirm modal
    hideModal();
  };

  const handleConfirmModalClose = () => {
    setShowConfirmModal(false); // Hide back modal on cancel
  };
  //#endregion

	return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered>
        <Modal.Header>
          <div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
            <Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Reject Leave</Modal.Title>
          </div> 
        </Modal.Header>
        <Modal.Body>
					<Comp.Input
            id="REMARK"
            label="Reason*"
            name="Reject reason"
            type="text"
            className="form-control"
            errorMessage={inputError.REMARK}
            value={editData.REMARK}
            onChange={inputRequiredHandler}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="onright-container">
            <Comp.Button
              id="btnCancel"
              type="cancel"
              onClick={handleBack}
            >
              <FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
            </Comp.Button>
                                
            <Comp.Button id="btnSave" onClick={handleConfirm}>
              <FontAwesomeIcon icon={faCheck} />&nbsp; Reject
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Confirmation Modal */}
      <BackModal
        show={showBackModal}
        onHide={handleConfirmBackCancel}
        onConfirm={handleConfirmBack}
        prop="Confirm Navigation"
      >
        Are you sure you want to go back? Your changes may be lost.
      </BackModal>

      <ConfirmModal
        show={showConfirmModal}
        onHide={handleConfirmModalClose}
        onConfirm={handleConfirmModal}
			  prop="Confirm to reject"
      >
        Are you sure you want to reject this leave?
      </ConfirmModal>

      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default LeaveRejected;